import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { fileUrl } from "../components/ImageUpload";

const ContentCtx = createContext({ content: {}, t: (k, d) => d, img: (k, d) => d, refresh: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(data.content || {});
    } catch { /* fallbacks used */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const t = (key, fallback = "") => {
    const v = content[key];
    if (v === undefined || v === null || v === "") return fallback;
    return v;
  };

  const img = (key, fallback = "") => {
    const v = content[key];
    if (!v) return fallback;
    if (v.startsWith("http") || v.startsWith("/")) return v;
    return fileUrl(v);
  };

  return <ContentCtx.Provider value={{ content, t, img, refresh }}>{children}</ContentCtx.Provider>;
}

export function useContent() {
  return useContext(ContentCtx);
}
